import { transport } from 'config/transport';

export function callApiExportCongDoanReportForAllCongDoan(academicYear, abroadOnly = false) {
    return transport.get(`/trunguong/report/congdoan/annually`, { params: { academicYear, abroadOnly }, responseType: 'blob' });
}
